import React from "react";
import { FormattedMessage } from "react-intl";
import { Box, Button, Container, Typography } from "@material-ui/core";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ReplayIcon from "@material-ui/icons/Replay";

// Pantalla después de pedir el enlace por email. api2 responde siempre lo mismo (no revela
// si la reserva existe o si se mandó), así que el texto tampoco lo afirma: dice qué revisar
// y deja volver a intentar. `secondsLeft` sigue el cooldown del servidor (30 s), durante el
// cual un nuevo pedido no reenvía nada.
const MagicLinkSent = ({ cid, contact, secondsLeft, onRetry, onBack }) => (
  <Box p={3} className="MagicLinkSent">
    <Container maxWidth="sm">
      <Box textAlign="center" pb={2}>
        <MailOutlineIcon color="primary" style={{ fontSize: 56 }} />
        <Typography variant="h6" component="h2" gutterBottom>
          <FormattedMessage id="login.magicLinkSent.title" />
        </Typography>
        <Typography variant="body1">
          <FormattedMessage
            id="login.magicLinkSent.body"
            values={{ cid: <strong>{cid}</strong> }}
          />
        </Typography>
      </Box>
      <Box pb={3}>
        <Typography variant="subtitle2" gutterBottom>
          <FormattedMessage id="login.magicLinkSent.tipsTitle" />
        </Typography>
        <Typography variant="body2" color="textSecondary" component="ul">
          <li>
            <FormattedMessage id="login.magicLinkSent.tipSpam" />
          </li>
          <li>
            <FormattedMessage id="login.magicLinkSent.tipCid" />
          </li>
          <li>
            {contact ? (
              <FormattedMessage
                id="login.magicLinkSent.tipContact"
                values={{ contact }}
              />
            ) : (
              <FormattedMessage id="login.magicLinkSent.tipContactGeneric" />
            )}
          </li>
        </Typography>
      </Box>
      <Button
        variant="contained"
        color="primary"
        size="large"
        fullWidth
        disabled={secondsLeft > 0}
        startIcon={<ReplayIcon />}
        onClick={onRetry}
      >
        {secondsLeft > 0 ? (
          <FormattedMessage
            id="login.magicLinkSent.retryIn"
            values={{ seconds: secondsLeft }}
          />
        ) : (
          <FormattedMessage id="login.magicLinkSent.retry" />
        )}
      </Button>
      <Box mt={2}>
        <Button
          variant="text"
          color="primary"
          size="large"
          fullWidth
          startIcon={<ChevronLeftIcon />}
          onClick={onBack}
        >
          <FormattedMessage id="login.magicLinkSent.back" />
        </Button>
      </Box>
    </Container>
  </Box>
);

export default MagicLinkSent;
